export default {
  dbl_common_all: "All",
  dbl_common_overall: "Overall",
  dbl_common_save: "Save",
  dbl_common_save_as: "Save As",
  dbl_common_clear: "Clear",
  dbl_common_confirm: "Confirm",
  dbl_common_reset: "Reset",
  dbl_common_cancel: "Cancel",
  dbl_common_back: "Back",
  dbl_common_close: "Close",
  dbl_common_stop: "Stop",
  dbl_common_save_to: "Save&Enter Dashboard",
  dbl_common_search: "Search",
  dbl_common_search_nothing: "No search results",
  dbl_common_nothing: "No results",
  dbl_common_add: "Add",
  dbl_common_delete: "Delete",
  dbl_common_no_data: "No Data Available",
  dbl_common_no_data2: "No data yet",
  dbl_common_no_filter_data: "No data under current filter selections",
  dbl_common_sql_error: 'There are some issues with the data source. Please check the data source.',
  dbl_common_not_found: 'Search item not found',
  dbl_common_leave: "Leave",
  dbl_common_leave_message: "The current {name}page has not been saved. Leaving will result in the loss of all content.",
  dbl_common_explore_leave_message: "Leaving will result in the loss of all content.",
  dbl_common_loading: "Loading...",
  dbl_common_load_fail: "Load failed",
  dbl_common_refresh: ", Refresh Retry",
  dbl_common_not_search: "Search content not found,",
  dbl_common_go_back_old: "return to the original list",
  dbl_common_error_code: "Error Code",
  dbl_common_return: "Return",
  dbl_common_select_all: "Select All",
  dbl_common_clear_all: "Clear All",
  dbl_common_day: "Day",
  dbl_common_week: "Week",
  dbl_common_month: "Month",
  // 图表类型
  dbl_common_table_title: "Table",
  dbl_common_line_title: "Line Chart",
  dbl_common_bar_title: "Bar Chart",
  dbl_common_pie_title: "Pie Chart",
  dbl_common_table: "Table",
  dbl_common_line: "Line Chart",
  dbl_common_bar: "Bar Chart",
  dbl_common_stack_bar: "Stack Bar Chart",
  dbl_common_pie: "Pie Chart",
  dbl_common_delete_successfully: 'Deleted successfully.',
  dbl_common_delete_failed: 'Delete Failed.',

  dbl_common_create_time: 'Create Time',
  dbl_common_creator: 'Creator',
  dbl_common_operation: 'Action',
  dbl_common_status: "Status",
  dbl_common_updater: "Editor",
  dbl_common_last_updater: "Last Updated By",
  dbl_common_editable_person: "Editable Person",
  dbl_common_edit: "Edit",
  dbl_common_publish: "Publish",
  dbl_common_un_publish: "Unpublish",
  dbl_common_published: "Published",
  dbl_common_un_published: "Unpublished",
  dbl_common_total: "Total {total} Items",
  dbl_common_select_placeholder: 'Please Select',
  dbl_common_select_no_data: 'No data available',
  dbl_common_dashboard_title: 'Dashboard ',
  dbl_common_name: 'Name',
  dbl_common_customize: 'Customize',
  dbl_common_customize_placeholder: 'Please enter a name for option',

  dbl_common_publish_successfully: '{name} published successfully.',
  dbl_common_publish_failed: 'Publishing failed! Error code {code}',
  dbl_common_un_publish_successfully: '{name} unpublished successfully.',
  dbl_common_un_publish_failed: 'Unpublish failed! Error code {code}',
  dbl_no_data: 'No data yet',
  dbl_common_least_select_one: 'Please select at least one option.',
	
  dbl_common_valida_required: 'Required',
  dbl_common_save_fail: 'Save Failed',
  dbl_common_save_success: "Save Success",
	
  dbl_common_include: 'Include',
  dbl_common_exclude: 'Exclude',
	
  dbl_common_cannot_be_empty: 'Cannot be empty',
  dbl_common_please_select: 'Please select {name}',
	
  dbl_common_dynamic_time: 'Dynamic Time',
  dbl_common_static_time: 'Static Time',
  dbl_common_static_time_info: 'The date does not change over time. If you choose 2023.1.1 to 2023.1.7, then the date will always be 2023.1.1 to 2023.1.7',
	
  dbl_common_dod_day: 'DoD',
  dbl_common_dod_date: 'DoD',
  dbl_common_dod_week: 'WoW',
  dbl_common_dod_month: 'MoM',
  dbl_common_sdlw_day: 'SDLW',
  dbl_common_sdlw_date: 'SDLW',
  dbl_common_sdlw_week: 'SWLM',
  dbl_common_sdlw_month: 'SMLY',
  dbl_common_change: 'Change',
  dbl_common_trend: 'Trend',
  dbl_common_show_static_time: 'Show Statistics Time',
  dbl_common_current_day: 'Today',
  dbl_common_current_date: 'Today',
  dbl_common_current_week: 'This Week',
  dbl_common_current_month: 'This Month',
	
  dbl_common_access: 'Access',
  dbl_common_no_access: 'No access',
  dbl_common_no_edit_access_tips: 'No editing permission, If you need to preview the Chart, you can view it in the Dashboard',
  
  dbl_common_download: 'Download',
  dbl_common_transpose: 'Transpose',
  
  dbl_common_search_result: 'Search result ({count})',
  dbl_common_selector_placeholder: 'Please Select',
  dbl_common_string_selector_placeholder: 'Please select value',
  
  dbl_common_valid_name: 'Please enter Chinese characters, numbers, uppercase and lowercase letters, spaces, parentheses, underscores, middle lines, and parentheses.',
  dbl_common_valid_name_length: "Cannot exceed {count} characters",
  
  dbl_common_dashboard_valid_name: "Please enter Chinese characters, numbers, uppercase and lowercase letters,  parentheses, underscores, middle lines, and spaces.",
  dbl_common_no_permission: 'No Permission',
  dbl_common_no_permission_desc:
    'You are currently logged in as a "Viewer", which allows viewing only. To make changes, please request "Editor" or higher permissions from your administrator.',
  
  dbl_common_fullscreen: 'Fullscreen',
  dbl_common_copy: 'Copy',
  dbl_common_copy_success: 'Copy successful!',
  dbl_common_copy_error: 'Copy fail!',
  
  dbl_common_others: 'Others',
  dbl_common_filter_invalid: 'The filter is invalid',
  dbl_common_default_value_invalid: 'The default value is Invalid',
  dbl_common_default_value_invalid_info: 'The default value does not match the options from the relevant filter. Please review and adjust the default value setting.',
  dbl_common_filter_field_error: 'Field does not exist',
  dbl_common_filter_reference_field_error: 'Reference field does not exist',
  
  dbl_common_default: 'Default',
  
  dbl_common_sort: 'Sort',
  dbl_common_sort_reset: 'Reset Sorting',
  dbl_common_sort_clear: 'Clear Sorting',
  dbl_common_yes: 'Yes',
  dbl_common_no: 'No',
  dbl_common_retry: 'Retry',
  
  dbl_common_detail: 'Detail',
  dbl_common_expand: "Expand",
  dbl_common_collapse: "Collapse",

  dbl_common_dashboard_disabled: 'This chart is already on the dashboard',
  dbl_common_pascal_custom: 'Custom',
  
  dbl_common_set_up: 'Set Up',

  dbl_common_number: 'number',
  dbl_common_refresh_text: 'Refresh',

  dbl_common_refresh_click: 'Click Refresh',

  dbl_common_download_type: 'File Format',
};